<wbo-search-page [showOpenButton]="true" (onOpen)="openEntity($event)">
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="identifier">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="sellableType">
                <wbo-single-select-search-control>
                    <wbo-select-options>
                        <wbo-select-option value="productLineData" label="wbo.sellable.search.option.sellable-type.product-line">
                        </wbo-select-option>
                        <wbo-select-option value="compositeProductData" label="wbo.sellable.search.option.sellable-type.composite-product">
                        </wbo-select-option>
                    </wbo-select-options>
                </wbo-single-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
        <wbo-search-form-extended-fields>
            <wbo-search-form-field *extendedField="'category'">
                <wbo-category-exclude-sub-search-control></wbo-category-exclude-sub-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'inventoryId'">
                <wbo-inventory-multi-select-search-control></wbo-inventory-multi-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'customObjectId'">
                <wbo-custom-object-multi-select-search-control [productLineContext]="true"></wbo-custom-object-multi-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'status'">
                <wbo-entity-availability-single-select-search-control></wbo-entity-availability-single-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-extended-fields>
    </wbo-search-form>
    <wbo-entity-actions [title]="'wbo.sellable.search.actions.add'">
        <wbo-entity-action
            [title]="'wbo.sellable.search.actions.addProductLine'"
            (click)="newProductLine()"></wbo-entity-action>
        <wbo-entity-action
            [title]="'wbo.sellable.search.actions.addCompositeProduct'"
            (click)="newCompositeProduct()"></wbo-entity-action>
    </wbo-entity-actions>
    <wbo-search-grid>
        <wbo-main-search-column field="name"></wbo-main-search-column>
        <wbo-currency-column field="price"></wbo-currency-column>
        <wbo-column field="plu"></wbo-column>
        <wbo-column field="categoryName"></wbo-column>
    </wbo-search-grid>
</wbo-search-page>
